<template>
  <div
    :content="label"
    v-tippy="{
      arrow: true,
      theme: statusButton(status).theme,
    }"
    :class="disableAdd && !['ADDED', 'HIDDEN'].includes(status) ? 'hidden' : ''"
  >
    <button
      :disabled="disableAdd"
      :class="statusButton(status).color"
      class="inline-flex h-8 w-8 items-center justify-center rounded-full transition"
    >
      <div
        v-html="statusButton(status).icon"
        :class="!status || status === 'EXTENSION' ? 'pl-0.5 pt-1' : ''"
        class="text-ontick-graphite-500"
      ></div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    status: { type: String },
    label: { type: String },
    disableAdd: { type: Boolean, default: false },
  },
  methods: {
    statusButton(status) {
      const statusList = {
        default: {
          color: "bg-ontick-green-500 hover:bg-ontick-green-400",
          icon: this.$icons.material_plus_xs,
          theme: "green",
        },
        ADDED: {
          color: "bg-ontick-blue-600 hover:bg-ontick-blue-400",
          icon: this.$icons.material_check,
          theme: "blue",
        },
        HIDDEN: {
          color: "bg-ontick-yellow-600 hover:bg-ontick-yellow-500",
          icon: this.$icons.material_arquive,
          theme: "yellow",
        },
      };
      return statusList[status] || statusList.default;
    },
  },
};
</script>

<style></style>
